export default "__VITE_ASSET__448f17cf__"